import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useTypeAttributeStore } from "../../../hooks/useTypeAttributeStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const TypeAttributeModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, typeattributeSelected, listTypeAttribute, clearState } = props;

    const { action, createtypeAttribute, edittypeAttribute } = useTypeAttributeStore();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Values>({
        id: typeattributeSelected ? typeattributeSelected.id :'',
        code: typeattributeSelected ? typeattributeSelected.code :'',
        name: typeattributeSelected ? typeattributeSelected.name :'',
        description: typeattributeSelected ? typeattributeSelected.description :'',
        status: typeattributeSelected ? typeattributeSelected.status :'1',
    });


    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const formData = {...values}

        if(typeattributeSelected){
            const response:any = await edittypeAttribute(typeattributeSelected.id, formData);
            if(response){
                listTypeAttribute && listTypeAttribute();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createtypeAttribute(formData);
            if(response){
                listTypeAttribute && listTypeAttribute();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: open ? 'slide-in 0.3s ease-out' : 'slide-out 0.3s ease-in', maxHeight: '100%', height: '100vh'}}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar tipo atributo de producto' : (action == 'add' ? 'Nuevo tipo atributo de producto' : '')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Código:</FormLabel>
                                            <TextField
                                            id="code"
                                            type="text" 
                                            name="code"
                                            fullWidth
                                            size="small"
                                            value={values.code}
                                            onChange={handleChange}
                                            error={errors.code && touched.code ? true : false}
                                            helperText={errors.code && touched.code ? errors.code : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Nombre del atributo:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        {
                                            !typeattributeSelected && (
                                                <Grid item xs={12} md={4}>
                                                    <FormLabel>Estado:</FormLabel>
                                                    <Select
                                                        id="status"
                                                        value={values.status}
                                                        size="small"
                                                        onChange={(event) => { 
                                                            setFieldValue("status", event.target.value);
                                                        }}
                                                        error={ errors.status && touched.status ? true : false }
                                                        fullWidth
                                                    >
                                                        {
                                                            states.map((state, i) => {
                                                                return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                            })
                                                        }
                                                    </Select>
                                                </Grid>
                                            )
                                        }
                                        <Grid item xs={12} md={8}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>     
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}